import { FreeTShirt } from '@bgea-js/form-templates';
import customConfirmationFronteraDevotional from "../../../../src/content/frontera-giveaway-devos/customConfirmation";
import customConfirmationFronteraDevotionalES from "../../../../src/content/frontera-giveaway-devos/customConfirmationES";
import * as React from 'react';
export default {
  FreeTShirt,
  customConfirmationFronteraDevotional,
  customConfirmationFronteraDevotionalES,
  React
};